import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import React, { ReactNode } from 'react';
import VerticalScroll from '../ScrollBar/VerticalScroll';
import Card from './Card';

const StyledCard = styled(Card)(({ theme }) => ({
  overflow: 'hidden',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    height: '100%'
  }
}));

interface CanvasCellProps {
  id: string;
  title: string;
  children: ReactNode;
  icon: JSX.Element;
  className?: string;
}

const CanvasCell = ({ id, title, children, icon, className = '' }: CanvasCellProps) => {
  return (
    <StyledCard className={className}>
      <CardHeader
        title={title}
        titleTypographyProps={{ align: 'justify', variant: 'h6' }}
        avatar={icon}
        data-testid="canvas-cell-header"
      />
      <VerticalScroll>
        <CardContent id={id} sx={{ px: 0 }}>
          <List data-testid="canvas-cell-list">{children}</List>
        </CardContent>
      </VerticalScroll>
    </StyledCard>
  );
};

export default CanvasCell;
